import '../styles/food-search-sheet.css';
import { useEffect, useRef, type ReactNode } from 'react';
import { tg as telegram } from '../lib/telegram';

/** Search owns its viewport and traps focus; the real routed diary stays behind it. */
export function FoodSearchSheet({children,onClose,returnLabel}:{children:ReactNode;onClose:()=>void;returnLabel:string}) {
 const panel=useRef<HTMLDivElement>(null), close=useRef(onClose);close.current=onClose;
 useEffect(()=>{
  const background=document.querySelector<HTMLElement>('[data-food-background]');
  const previousFocus=document.activeElement as HTMLElement|null;
  const overflow=document.body.style.overflow;
  const wasInert=background?.inert ?? false;
  if(background)background.inert=true;
  document.body.style.overflow='hidden';
  const element=panel.current!;
  const app=telegram();
  const size=()=>{
   const vv=window.visualViewport;
   const height=Math.min(vv?.height ?? window.innerHeight, app?.viewportHeight || window.innerHeight);
   element.parentElement!.style.height=`${height}px`;
   element.parentElement!.style.top=`${vv?.offsetTop ?? 0}px`;
  };
  size();window.visualViewport?.addEventListener('resize',size);window.visualViewport?.addEventListener('scroll',size);window.addEventListener('resize',size);app?.onEvent?.('viewportChanged',size);
  const focusables=()=>Array.from(element.querySelectorAll<HTMLElement>('button:not(:disabled),input,a[href],[tabindex="0"]')).filter(e=>e.getClientRects().length);
  const key=(event:KeyboardEvent)=>{
   if(event.key==='Escape'){event.preventDefault();event.stopPropagation();close.current();}
   if(event.key==='Tab') {const items=focusables(),first=items[0],last=items.at(-1);if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}}
  };
  const focus=(event:FocusEvent)=>{if(!element.contains(event.target as Node))focusables()[0]?.focus();};
  document.addEventListener('keydown',key);document.addEventListener('focusin',focus);
  element.querySelector('input')?.focus({preventScroll:true});
  return ()=>{
   document.removeEventListener('keydown',key);document.removeEventListener('focusin',focus);
   window.visualViewport?.removeEventListener('resize',size);window.visualViewport?.removeEventListener('scroll',size);window.removeEventListener('resize',size);app?.offEvent?.('viewportChanged',size);
   if(background)background.inert=wasInert;document.body.style.overflow=overflow;
   if(previousFocus?.isConnected)previousFocus.focus({preventScroll:true});
   else background?.querySelector<HTMLElement>(`button[aria-label="${returnLabel}"]`)?.focus({preventScroll:true});
  };
 },[returnLabel]);
 return <div className="app food-search-overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}><div className="food-search-sheet" ref={panel} role="dialog" aria-modal="true" aria-label="Поиск продукта"><div className="grab" />{children}</div></div>;
}
